import { RepositoryFactory } from '@/repository/RepositoryFactory'

const OrderRepository = RepositoryFactory.get('order')

export default {
  methods: {
    async getRememberReason(key) {
      this.statusOptions = localStorage.getItem('order_statuses')
        ? JSON.parse(localStorage.getItem('order_statuses'))
        : (await OrderRepository.getFullStatusList()).data.data
      if (!localStorage.getItem('order_statuses')) {
        localStorage.setItem(
          'order_statuses',
          JSON.stringify(this.statusOptions),
        )
      }
      const rememberReason = this.statusOptions.find(n => n.key === key)
      return rememberReason ? rememberReason.is_remember_reason_enabled : false
    },
    getLightBackground(hex) {
      if (/^#[0-9A-F]{6}$/i.test(hex)) {
        const r = parseInt(hex.substr(1, 2), 16)
        const g = parseInt(hex.substr(3, 2), 16)
        const b = parseInt(hex.substr(5, 2), 16)
        return `rgba(${r}, ${g}, ${b}, 0.12)` // 12% opacity for soft bg
      }
      return 'rgba(0,0,0,0.07)' // fallback
    },
  },
}
